export function SettingsSheet({ onClose }: { onClose: () => void }) {
  return (
    <div className="absolute inset-0 z-20 flex items-end justify-center bg-slate-900/30 sm:items-center">
      <div className="w-full max-w-md rounded-t-2xl bg-white pb-safe shadow-2xl sm:rounded-2xl">
        <div className="mx-auto mt-2 h-1.5 w-10 rounded-full bg-slate-300 sm:hidden" aria-hidden />
        <div className="px-5 pt-4 pb-5">
          <div className="flex items-start justify-between">
            <h2 className="text-lg font-semibold text-slate-900">設定・出典</h2>
            <button
              type="button"
              onClick={onClose}
              className="rounded-full bg-slate-100 px-3 py-1 text-sm text-slate-600 active:bg-slate-200"
              aria-label="閉じる"
            >
              閉じる
            </button>
          </div>
          <section className="mt-4 space-y-4 text-sm text-slate-700">
            <div>
              <h3 className="font-semibold text-slate-800">データ出典</h3>
              <ul className="mt-1 list-disc space-y-1 pl-5">
                <li>暑さ指数（WBGT）：環境省熱中症予防情報サイト</li>
                <li>気温予報：気象庁ホームページ</li>
                <li>区域境界：気象庁 二次細分区域 GeoJSON</li>
                <li>地図タイル：地図データ © 国土地理院（淡色地図）</li>
              </ul>
            </div>
            <div>
              <h3 className="font-semibold text-slate-800">WBGT 値について（近似値）</h3>
              <p className="mt-1">
                マップ上に表示している WBGT は、環境省が観測点ごとに発表する <strong>予測値</strong>（実測ではありません）です。
              </p>
              <p className="mt-1">
                さらに、地域単位の色塗りは観測点の予測値を <strong>最寄りの観測点で各区域に拡張した近似表示</strong>で、同じ区域内でも実際の気象条件は場所によって異なります。あくまで目安としてご利用ください。
              </p>
            </div>
            <div>
              <h3 className="font-semibold text-slate-800">サービス期間</h3>
              <p className="mt-1">毎年 4月22日〜10月21日（環境省WBGT配信期間に同調）</p>
            </div>
            <div>
              <h3 className="font-semibold text-slate-800">バージョン</h3>
              <p className="mt-1">0.1.0（プロトタイプ）</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
